module.exports = __webpack_public_path__ + "assets/stability_primary.d36f0f10.svg";